import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        marginRight: 'auto',
    },
    title: {
        color: COLOR.NEUTRAL,
        fontFamily: Fonts.main.bold,
        fontSize: 16,
        paddingHorizontal: 18,
        paddingVertical: 8,
    },
    webMenuItem: {
        // @ts-ignore
        cursor: 'pointer',
    },
});

export default styles;
